
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wellmaxx/[...slug]",
      function () {
        return require("private-next-pages/wellmaxx/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wellmaxx/[...slug]"])
      });
    }
  